import 'mburger-webcomponent/dist/mburger/index.js';
import 'mmenu-js/dist/mmenu.js';

(($) => {
  const $window = $(window);
  const $body = $('body');

  $(() => {
    const $mobileMenu = $('#mobile-menu');

    if ($mobileMenu.length) {
      const $burger = $('mm-burger');

      const openBurger = () => {
        $burger.addClass('text-primary').get(0).state = 'cross';
      };

      const closeBurger = () => {
        $burger.removeClass('text-primary').get(0).state = 'bars';
      };

      const options = {
        slidingSubmenus: true,
        navbar: {
          add: true,
          title: 'Menu',
          titleLink: 'none',
        },
        offCanvas: {
          use: true,
          position: 'bottom',
        },
        hooks: {
          'close:after': () => {
            closeBurger();
          },
        },
      };

      const configuration = {
        offCanvas: {
          page: {
            selector: '#master',
          },
        },
      };

      const mmenu = new Mmenu($mobileMenu.get(0), options, configuration);

      $mobileMenu.show();

      const closeMenu = () => {
        mmenu.close();
        closeBurger();
      };

      const openMenu = () => {
        mmenu.open();
        openBurger();
      };

      $burger.on('click', () => {
        $body.hasClass('mm-wrapper--opened') ? closeMenu() : openMenu();
      });

      $window.on('resize', () => {
        if (window.matchMedia('(min-width: 1200px)').matches) closeMenu();
      });

      $mobileMenu.on('click', '.mm-navbar__title', (e) => {
        const $navbarTitle = $(e.currentTarget);
        const $navbarButton = $navbarTitle.siblings('.mm-navbar__btn');

        if ($navbarButton.length) {
          $navbarButton.get(0).click();
        }
      });
    }
  });
})(jQuery);
